import styled from 'styled-components';
import React from 'react';
import { IoIosCheckmarkCircle } from 'react-icons/io';

export function PriceTestStepDone() {
  return (
    <Wrapper>
      <IoIosCheckmarkCircle size={70} color="rgb(61, 71, 245)" />
      <span>
        Thanks, all set! Pricing tests are more complex and affect your entire
        site. Our CRO expert will review your test and get back to you within 3
        business days. Once approved, the status will change from Pending to
        Ready and you will be able to preview and publish the test. <br />
        We will contact you via chat if we need any more information.
      </span>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0;

  height: 100%;

  span {
    padding: 0 2rem;
    font-size: 1.3rem;
    color: rgb(168, 175, 183);
    line-height: 1.8;
    text-align: center;
  }
`;
